import React from 'react';

import application from 'application';

import internalEventCodes from 'event-system/codes/internal';

import { ReactComponent as CopyIcon } from 'assets/images/copy-icon.svg';

import './index.scss';

function DisplayTextToCopy(props) {

  const { text } = props;

  function handleCopyToClipboardControl() {

    navigator.clipboard.writeText(text);

    application.eventSystem.internal.emit(internalEventCodes.DISPLAY_SYSTEM_TOAST_MESSAGE, {
      message: 'Copied to clipboard!',
      seconds: 5,
      type: 'info'
    });

  }

  function renderCopyControl() {

    const copyControlAttributes = {
      className: 'copy-to-clipboard-control',
      onClick() {
        handleCopyToClipboardControl();
      }
    };

    return <button {...copyControlAttributes}>
      <CopyIcon className="copy-icon" />
    </button>;

  }

  function renderMain() {

    return <div className="display-text-to-copy-main">

      <span className="text ellipsis">{text}</span>

      {renderCopyControl()}

    </div>;

  }

  return renderMain();

};

export default DisplayTextToCopy; 